import { Input } from "@brg/input";
import { BaseSyntheticEvent, FC, SyntheticEvent, useEffect, useMemo } from "react";
import { RowContainer } from "../styles";
import { useDispatch, useSelector } from "react-redux";
import { TagAdminActions, TagAdminSelector } from "shared/reducers/tagAdminSlice";
import { fetchCurrentPlatformData, fetchPlatformCategoryOpt } from "shared/actions/tagAdminActions";
import useQueryState from "shared/hooks/useQueryState";
import { useTranslation } from "react-i18next";
import { CommonInput, INPUT_TYPES } from "@brg/ui";
import { OPTION_TYPE } from "@brg/ui/dist/types/ui-input/types";
import TagsTypeSwitcher from "./TagsTypeSwitcher";
import { ApplicationShared } from "core";
import { AppTester } from "supporting";

export const getComputeAppName = (obj: any) => {
    return `${obj.appName}/${obj?.context}`
}

export const getComputeLabel = (obj: any) => {
    return obj?.url
}

export const Platforms: FC<{ 
    onUpdate: (t: any) => void, 
    update?: number 
}> = ({ 
    onUpdate, 
    update 
}) => {
    const { t } = useTranslation();
    const isSinglePlatform = AppTester.isFr();
    const defaultPlatformName = isSinglePlatform
        ? ApplicationShared.application
        : 'deziiign/main';
    const initialValue = { value: defaultPlatformName, label: defaultPlatformName }
    const dispatch = useDispatch();
    const [{ cPlat }, setQueryParams] = useQueryState();

    const { currentPlatform, platforms, type  } = useSelector(TagAdminSelector);

    useEffect(() => {
        dispatch(fetchPlatformCategoryOpt())
    }, [update])
    
    useEffect(() => {
        if (!currentPlatform?.platform) {
            dispatch(fetchCurrentPlatformData({ platformName: cPlat || defaultPlatformName }))
        }
    } , [currentPlatform?.platform, dispatch, platforms, cPlat, defaultPlatformName])

    const options = useMemo(() => {
        if (defaultPlatformName === 'fr/main') {
            return platforms?.reduce((acc, i) => {
                if (i?.appName === 'fr') {
                    acc.push({
                        value: getComputeAppName(i),
                        label: i?.url
                    })
                }
                return acc;
            }, [] as { value: string, label: string }[])
        }
       return platforms?.map((i) => {
            return { value: getComputeAppName(i), label: i?.url }
       })
    } , [platforms])

    const currentOpt = useMemo(
        () => !currentPlatform?.platform ? initialValue : { 
            value: getComputeAppName(currentPlatform?.platform), 
            label: getComputeLabel(currentPlatform?.platform)
        } 
    , [currentPlatform, initialValue])

    const onSetCurrentPlatform = ({ label, value }: OPTION_TYPE) => {
        //@ts-ignore
        const platform = platforms?.find((i) => getComputeAppName(i) === value)
        dispatch(fetchCurrentPlatformData({ platformName: getComputeAppName(platform)}))
        dispatch(TagAdminActions.toggleEditMode(false));
        setQueryParams({ cPlat: getComputeAppName(platform) })
        onUpdate(Date.now());
    }

    return (
        <RowContainer offsetBottom={56} gy={24}>
            <span className={'label'}>
                {t('main_admin_tag.platform_title')}
            </span>
            <TagsTypeSwitcher />
            <CommonInput
                type={INPUT_TYPES.dropdown}
                value={currentOpt}
                options={options}
                onChange={onSetCurrentPlatform}  
                maxLength={75}
            />
        </RowContainer>
    )
}import { Input } from "@brg/input";
import { BaseSyntheticEvent, FC, SyntheticEvent, useEffect, useMemo } from "react";
import { RowContainer } from "../styles";
import { useDispatch, useSelector } from "react-redux";
import { TagAdminActions, TagAdminSelector } from "shared/reducers/tagAdminSlice";
import { fetchCurrentPlatformData, fetchPlatformCategoryOpt } from "shared/actions/tagAdminActions";
import useQueryState from "shared/hooks/useQueryState";
import { useTranslation } from "react-i18next";
import { CommonInput, INPUT_TYPES } from "@brg/ui";
import { OPTION_TYPE } from "@brg/ui/dist/types/ui-input/types";
import TagsTypeSwitcher from "./TagsTypeSwitcher";
import { ApplicationShared } from "core";
import { AppTester } from "supporting";

export const getComputeAppName = (obj: any) => {
    return `${obj.appName}/${obj?.context}`
}

export const getComputeLabel = (obj: any) => {
    return obj?.url
}

export const Platforms: FC<{ 
    onUpdate: (t: any) => void, 
    update?: number 
}> = ({ 
    onUpdate, 
    update 
}) => {
    const { t } = useTranslation();
    const isSinglePlatform = AppTester.isFr();
    const defaultPlatformName = isSinglePlatform
        ? ApplicationShared.application
        : 'deziiign/main';
    const initialValue = { value: defaultPlatformName, label: defaultPlatformName }
    const dispatch = useDispatch();
    const [{ cPlat }, setQueryParams] = useQueryState();

    const { currentPlatform, platforms, type  } = useSelector(TagAdminSelector);

    useEffect(() => {
        dispatch(fetchPlatformCategoryOpt())
    }, [update])
    
    useEffect(() => {
        if (!currentPlatform?.platform) {
            dispatch(fetchCurrentPlatformData({ platformName: cPlat || defaultPlatformName }))
        }
    } , [currentPlatform?.platform, dispatch, platforms, cPlat, defaultPlatformName])

    const options = useMemo(() => {
        if (defaultPlatformName === 'fr/main') {
            return platforms?.reduce((acc, i) => {
                if (i?.appName === 'fr') {
                    acc.push({
                        value: getComputeAppName(i),
                        label: i?.url
                    })
                }
                return acc;
            }, [] as { value: string, label: string }[])
        }
       return platforms?.map((i) => {
            return { value: getComputeAppName(i), label: i?.url }
       })
    } , [platforms])

    const currentOpt = useMemo(
        () => !currentPlatform?.platform ? initialValue : { 
            value: getComputeAppName(currentPlatform?.platform), 
            label: getComputeLabel(currentPlatform?.platform)
        } 
    , [currentPlatform, initialValue])

    const onSetCurrentPlatform = ({ label, value }: OPTION_TYPE) => {
        //@ts-ignore
        const platform = platforms?.find((i) => getComputeAppName(i) === value)
        dispatch(fetchCurrentPlatformData({ platformName: getComputeAppName(platform)}))
        dispatch(TagAdminActions.toggleEditMode(false));
        setQueryParams({ cPlat: getComputeAppName(platform) })
        onUpdate(Date.now());
    }

    return (
        <RowContainer offsetBottom={56} gy={24}>
            <span className={'label'}>
                {t('main_admin_tag.platform_title')}
            </span>
            <TagsTypeSwitcher />
            <CommonInput
                type={INPUT_TYPES.dropdown}
                value={currentOpt}
                options={options}
                onChange={onSetCurrentPlatform}  
                maxLength={75}
            />
        </RowContainer>
    )
}